// removed by extract-text-webpack-plugin
module.exports = {"activeText":"src-components-Footer-__Footer-module___activeText","tripAdded":"src-components-Footer-__Footer-module___tripAdded"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.module.css
// module id = 1010
// module chunks = 0